import CallCenterCrmApi from './CallCenterCrmApi'
var Api = new CallCenterCrmApi({
  url: process.env.BASE_API
})
export default Api



// WEBPACK FOOTER //
// ./src/api/api.js